// extracted by mini-css-extract-plugin
export default {"fadeContainer":"RetenesPage_fadeContainer__zXWTm","mounted":"RetenesPage_mounted__Cactb"};